import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTvadCrossChannelIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3.88808 16.3957L3.88701 16.3964C3.70013 16.5059 3.40185 16.5349 3.14273 16.4537C3.0773 16.4332 3.03078 16.4105 3 16.3922V5.10829C3.03083 5.08989 3.07747 5.06711 3.1431 5.04652C3.40253 4.96513 3.70114 4.99394 3.88808 5.10317C3.8881 5.10318 3.88812 5.1032 3.88814 5.10321L13.5466 10.7495L3.88808 16.3957Z",
		stroke: "#977AFF",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("circle", {
		cx: 14.25,
		cy: 10.75,
		r: 5.75,
		stroke: "#977AFF",
		strokeWidth: 2
	})]
});
export default SvgTvadCrossChannelIcon;
